import { render, staticRenderFns } from "./UserTrader.vue?vue&type=template&id=663a4622&"
import script from "./UserTrader.vue?vue&type=script&lang=js&"
export * from "./UserTrader.vue?vue&type=script&lang=js&"
import style0 from "./UserTrader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports